import script from "./hardware-warning-zone.vue?vue&type=script&lang=ts&setup=true"
export * from "./hardware-warning-zone.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__